import { render, staticRenderFns } from "./QueryRealName.vue?vue&type=template&id=3884cb1c&scoped=true&"
import script from "./QueryRealName.vue?vue&type=script&lang=js&"
export * from "./QueryRealName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884cb1c",
  null
  
)

export default component.exports